export default __webpack_public_path__ + "0bbccba3e56f945ac1419ffbd5aebd80.svg";